import {
    AVIS_INICIALITZAR,
    AVIS_INTRODUCCIO_MODIFICAR_VIGILANT,
    AVIS_OMPLIR_FORMULARI_AMB_UN_AVIS
} from '../../../../actions/actionTypes';


export const ESTAT_INICIAL = null;

const idVigilant = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {

        case AVIS_INICIALITZAR:
            return ESTAT_INICIAL;

        case AVIS_INTRODUCCIO_MODIFICAR_VIGILANT:
            return action.idVigilant;

        case AVIS_OMPLIR_FORMULARI_AMB_UN_AVIS:
            return action.avis.vigilant.id;

        default:
            return state;
    }
};

export default idVigilant;



// WEBPACK FOOTER //
// ./src/reducers/avis/formulari/dades/idVigilant.js